import { CONFIG_COURSE } from '@vedalib/editor/lib/elements'
import { useEmbedParams } from 'hooks/useEmbedParams'
import * as R from 'ramda'
import { useEffect } from 'react'

import { useElementStyleValues } from 'services/Branding/hooks'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getDeviceMode, getDeviceWidth } from 'services/Store/Project/selectors'

import { COURSE_HEADER_HEIGHT } from '../cource/controls/CourseHeader/constants'

export const UseAbsoluteSizes = () => {
  const deviceMode = useProjectContext(getDeviceMode)
  const width = useProjectContext(getDeviceWidth)
  const { hideHeader } = useEmbedParams()

  const showHeaderBrand = !useElementStyleValues(CONFIG_COURSE.header.type, deviceMode).panel
    .showHeader
  const showHeader = !hideHeader && showHeaderBrand

  useEffect(() => {
    const sizes = {
      '--vw': `1vh`,
      '--vh': `calc((100vh - ${showHeader ? COURSE_HEADER_HEIGHT : 0}px) / 100)`,
    }

    const style = document.documentElement.style
    R.forEachObjIndexed((value, key) => style.setProperty(key, value), sizes)
    return () => {
      R.forEachObjIndexed((_value, key) => style.removeProperty(`--brand-${String(key)}`), sizes)
    }
  }, [width, showHeader])

  return null
}
